import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, InjectionToken, NgModule } from '@angular/core';
import { APP_BASE_HREF, Location } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';

import { HttpRequestInterceptor } from './guards/http-request-interceptor.service';

import { CreditCardFormComponent } from './components/shared/credit-card-form/credit-card-form.component';
import { GiftCardFormComponent } from './components/shared/gift-card-form/gift-card-form.component';
import { AlertBoxComponent } from './components/shared/alert-box/alert-box.component';

import { InvoiceComponent } from './components/invoice/invoice.component';
import { InvoiceHeaderComponent } from './components/invoice/header/header.component';
import { InvoiceFooterComponent } from './components/invoice/footer/footer.component';
import { InvoiceViewComponent } from './components/invoice/view/view.component';
import { InvoicePayComponent } from './components/invoice/payment/payment.component';
import { InvoiceSuccessComponent } from './components/invoice/confirmation/confirmation.component';
import { CookieService } from 'ngx-cookie-service';
import { AppErrorHandler } from './core/app-error-handler/app-error-handler';
import { CoreModule } from './core/core.module';
import { DownloadButtonComponent } from './components/shared/download-button/download-button.component';
import { LocalLoaderSpinnerComponent } from './components/shared/local-loader-spinner/local-loader-spinner.component';
import { PercentagePipe } from './components/pipes/percentage.pipe';
import { TranslocoRootModule } from './transloco-root.module';
import { BrandService } from './services/brand/brand.service';
import { BrandConfigService } from './core/services/brand-config.service';


@NgModule({
  declarations: [
    AppComponent,   
    CreditCardFormComponent,
    GiftCardFormComponent,
    AlertBoxComponent,
    InvoiceComponent,
    InvoiceHeaderComponent,
    InvoiceFooterComponent,
    InvoiceViewComponent,
    InvoicePayComponent,
    InvoiceSuccessComponent,
    LocalLoaderSpinnerComponent,
    DownloadButtonComponent,
    PercentagePipe
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    CoreModule,
    TranslocoRootModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    },
    CookieService,
    BrandConfigService,
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    },
    {
      provide: APP_BASE_HREF,
      useFactory: (config: BrandConfigService) => {
        return config.get('appBaseHref')
      },
      deps: [BrandConfigService]
    }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule { }


